module.exports = __webpack_public_path__ + "img/Property 1=4x3, Property 2=DE - Germany.17d271f4.svg";